import React from '@root/vendor/react';

const CurrentUserContext = React.createContext();

export default CurrentUserContext;
